import { render, staticRenderFns } from "./UPSShip_LEGACY.vue?vue&type=template&id=1c796b25&scoped=true"
import script from "./UPSShip_LEGACY.vue?vue&type=script&lang=js"
export * from "./UPSShip_LEGACY.vue?vue&type=script&lang=js"
import style0 from "./UPSShip_LEGACY.vue?vue&type=style&index=0&id=1c796b25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c796b25",
  null
  
)

export default component.exports